export default __webpack_public_path__ + "static/media/jsc.b8efd749.png";